export const CATEGORIES = ['configurator']
